<header class="container-header">
  <umss-icon [name]="iconName()" [size]="iconSize()" />
  <span class="title">{{ title() }}</span>
</header>
